<template>
  <div class="row login-normal-container mfa-text">
    <div class="col-lg-6 col-md-6 flex justify-center">
      <mfa-template>
        <template v-slot:svg>
          <div class="mfa-logo-verification"></div>
        </template>
        <template v-slot:header>
          <div class="mfa-main-title text-zt-primary-200 text-zt-xl font-medium mb-4">{{$t('message.mfa.code_authentication.title')}}</div>
        </template>
        <template v-slot:subtitle>
          <div class="text-zt-dark-300 mb-2 mfa-wrong-code text-white py-2 px-3" v-if="wrongCode">
            {{$t('message.mfa.code_authentication.sub_title_wrong_code')}}
          </div>
          <div v-else class="text-zt-dark-300">
            <p class="mfa-description mb-4">{{$t('message.mfa.code_authentication.sub_title_valid_code')}}<span class="font-bold ml-2">{{ userEmail }}</span></p>
          </div>
          <div class="text-zt-dark-300">
            <p class="mfa-description" v-if="buttonResendEnabled">
              {{$t('message.mfa.code_authentication.sub_title_expired_code')}} &nbsp;<a href="#" @click="sendValidationCodeAgain" class="" data-vs-button="button-mfa-auth-resend-validation-code"><b><u>{{$t('message.mfa.code_authentication.sub_title_resend_code')}}</u></b></a>
            </p>
          </div>
          <p class="inline" v-if="!buttonResendEnabled">
            {{$t('message.mfa.code_authentication.sub_title_time_expired_code')}} <Timer @endTime="enableResendButton"></Timer>
          </p>
        </template>
        <template v-slot:form>
          <div class="flex justify-between mb-8 w-full px-5">
            <input id="codePart1" class="bg-zt-dark-200 mfa-input-code text-center text-zt-lg" maxlength="1" type="text" placeholder="0"/>
            <input id="codePart2" class="bg-zt-dark-200 mfa-input-code text-center text-zt-lg" maxlength="1" type="text" placeholder="0"/>
            <input id="codePart3" class="bg-zt-dark-200 mfa-input-code text-center text-zt-lg" maxlength="1" type="text" placeholder="0"/>
            <input id="codePart4" class="bg-zt-dark-200 mfa-input-code text-center text-zt-lg" maxlength="1" type="text" placeholder="0"/>
            <input id="codePart5" class="bg-zt-dark-200 mfa-input-code text-center text-zt-lg" maxlength="1" type="text" placeholder="0"/>
            <input id="codePart6" class="bg-zt-dark-200 mfa-input-code text-center text-zt-lg" maxlength="1" type="text" placeholder="0"/>
          </div>
        </template>
        <template v-slot:submitButtons>
          <div class="flex justify-between">
            <div class="w-1/2 mr-4">
              <zt-button outlined style="color:#4f41a3 !important;" @click="backToLogin" class="text-zt-lg w-full" data-vs-button="button-mfa-auth-back-login">{{$t('message.mfa.code_authentication.go_back_btn')}}</zt-button>
            </div>
            <div class="w-1/2">
              <zt-button v-if="!sending" @click="sendMFAValidationCode" class="text-zt-lg w-full mb-2" data-vs-button="button-mfa-auth-send-validation-code">{{$t('message.mfa.code_authentication.send_btn')}}</zt-button>
              <zt-button v-else :disabled="true" class="text-zt-lg w-full mb-2">{{$t('message.mfa.code_authentication.sending_btn')}}</zt-button>
            </div>
          </div>
        </template>
      </mfa-template>
      <a
          href="javascript:;"
          id="handlerModalRelated"
          data-toggle="modal"
          data-target="#switch-user"
      ></a>
    </div>
    <div id="imageBackground" class="col-lg-6 col-md-6 flex justify-center">
      <div v-if="$browserDetect.isChrome" class="logo-desktop"></div>
      <div v-else>
        <img :src="`${baseUrl}assets/images/background-login.png`" class="logo-desktop-noChrome"/>
      </div>
    </div>
  </div>
</template>

<script>
  import mfaTemplate from "./mfaTemplate";
  import MfaClient from "../../../apiClient/Mfa";
  import Timer from "./Timer";
  import User from "@/apiClient/User";
  import Actions from "@/apiClient/Actions";
  import axios from "axios";
  import Lo, {filter, find, isEmpty, map} from 'lodash'
  import moment from "moment";
  import {mapActions} from "vuex";
  export default {
    name: "mfaAuth",
    components: {
      mfaTemplate,
      Timer
    },
    props: {
      userEmail: {
        default: '',
        type: String
      },
      isFromLogin: {
        default: true,
        type: Boolean
      },
      jwt: {
        default: '',
        type: String
      },
      username: {
        default: '',
        type: String
      },
      password: {
        default: '',
        type: String
      },
    },
    data() {
      return {
        buttonResendEnabled: false,
        wrongCode: false,
        sending: false,
        employeeRelated: {},
        usersRelated: []
      }
    },
    methods: {
      ...mapActions({
        setParamLoginFactory: 'setParamLoginFactory'
      }),
      sendMFAValidationCode() {
        const inputs = document.getElementsByClassName('mfa-input-code')
        const codeMFA = [].map.call(inputs, function (input) {
          return input.value
        }).join('')
        this.sending = true;
        this.wrongCode = false;
        if (this.isFromLogin){
          this.mfaClient.validateAuthCode(codeMFA).then(response => {
            this.verificationSuccess()
          }).catch(e => {
            this.checkError(e);
          })
        }
        else{
          this.mfaClient.validateAuthCodeFromEmail(codeMFA).then(response => {
            this.verificationSuccess()
          }).catch(e => {
            this.checkError(e);
          })
        }
      },
      checkError(e) {
        let error = e.response.data;
        let code = error.codes[0].code;
        switch(code){
          case "SYSTEM_MFA_WRONG_CODE":
            this.wrongCode = true;
            this.resetCodeFields();
            break;
          case "SYSTEM_MFA_AUTH_MAX_FAILS_EXCEEDED":
              this.$emit('exceededFailsAuth')
            break;
          case "SYSTEM_MFA_AUTH_MAX_RESEND_EXCEEDED":
            this.$emit('exceededFailsAuth', 'maxResendFails')
            break;
          default:
            break;
        }
        this.sending = false;
      },
      sendValidationCodeAgain() {
        this.buttonResendEnabled = false;
        this.wrongCode = false
        this.resetCodeFields();
        this.sendEmailVerificationCode();
      },
      resetCodeFields() {
        const inputs = document.getElementsByClassName('mfa-input-code')
        Lo.map(inputs, input => {
          input.value = ''
        })
      },
      sendEmailVerificationCode(){
        if (this.isFromLogin) {
          this.mfaClient.sendVerificationCode().then(() => {
          }).catch(error => {
            this.checkError(error)
          });
        }
        else{
          this.mfaClient.sendEmailVerificationCode().then(() => {
          }).catch(error => {
            this.checkError(error)
          });
        }
      },
      enableResendButton() {
        this.buttonResendEnabled = true;
        this.wrongCode = false;
      },
      async verificationSuccess() {
        const { factory } = this.$route.query
        await this.managerUserRelated()
        if (parseInt(factory, 10) === this.employeeRelated.empresa.id) {
          this.setParamLoginFactory(factory)
          this.$route.query.factory = ''
        }
        await this.$store.dispatch("setSearchRRHH", {search: {}});
        await this.onSwitch(this.employeeRelated.id)
        await this.getActionsAndLoginPhp(this.employeeRelated, this.jwt, true);
      },
      async getActionsAndLoginPhp(usuario, tkn, noRelated) {
        if (noRelated) {
          await this.$store.dispatch("setJwt", {token: tkn});
          await this.$store.dispatch("setUser", {user: usuario});
        }
        let actions = new Actions();
        await actions.getActions().then(async result => {
          let res = result.status === 200 ? result.data.results.data : [];
          let fil = map(res, function(n) {
            return Number(n.id);
          });
          await this.$store.dispatch("setPermissions", {
            permissions: fil
          });

           if (this.$store.getters.isActionAllowed(305)) {
            await this.$store.dispatch('setNewDocumentWaiting')
          } else {
            await this.$store
              .dispatch('setDocumentsWaiting', {
                perPage: 10,
                page: 1,
                orderParams: null,
              })
              .catch((err) => { });
          } 
           this.$router.push("/home");
/*
          const bodyFormData = new FormData();
          bodyFormData.append("login", true);
          bodyFormData.append("usuario", this.username);
          bodyFormData.append("clave", this.password);
          const config = {
            headers: {
              "content-type": "multipart/form-data"
            }
          };
          await axios
            .post(location.origin + `/login`, bodyFormData, config) */
        });
      },
      onlyNumbers(textInput, filter) {
        ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
          textInput.addEventListener(event, function() {
            if (filter(this.value)) {
              this.oldValue = this.value
              this.oldSelectionStart = this.selectionStart
              this.oldSelectionEnd = this.selectionEnd
            } else if (this.hasOwnProperty("oldValue")) {
              this.value = this.oldValue
              this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd)
            } else {
              this.value = ""
            }
          })
        })
      },
      eventsInputsCode() {
        const inputs = [].slice.call(document.getElementsByClassName('mfa-input-code'))
        inputs.forEach((input, index, array) => {
          input.onkeypress = (event) => {
            let keyChar = String.fromCharCode(event.keyCode);
            if(!/^-?\d*$/.test(keyChar)) return event.preventDefault()
            let nexInput = index + 1
            if (nexInput < array.length) {
              array[nexInput].focus()
            }
          }
          input.onpaste = (event) => {
            let clip = event.clipboardData.getData('text').trim()
            if(!/^-?\d*$/.test(clip)) return event.preventDefault()
            const clipData = [...clip]
            Lo.map(inputs, (input, index) => {
              input.value = clipData[index] ? clipData[index] : ''
              input.focus()
            })
          }
        })
      },
      backToLogin() {
        this.$emit('backToLogin')
        this.resetCodeFields()
        localStorage.jwt = null;
        this.$store.dispatch("setJwt", {token: null});
      },
      async managerUserRelated() {
        const responseRelated = await this.user.relatedUsers();
        this.usersRelated = filter(responseRelated.data.results.data, userRelated =>
            find(userRelated.perfiles, profile => profile.id_perfil_tipo === 2)
        )
        if(isEmpty(this.usersRelated)) this.userRelatedEmpty = true
        this.$emit("usersRelated", this.usersRelated);
        this.employeeRelated = this.findDateLastSessionUser(this.usersRelated)
      },
      findDateLastSessionUser(listUserRelated) {
        let LastSessionUser = new Date(
            Math.max.apply(
                null,
                map(listUserRelated, userLastSession => {
                  const dateLasSession = moment(
                      userLastSession.ultimasession,
                      'DD-MM-YYYY hh:mm:ss'
                  ).format()
                  return new Date(dateLasSession)
                })
            )
        )
        return filter(
            listUserRelated,
            userWithLastSession =>
                new Date(
                    moment(
                        userWithLastSession.ultimasession,
                        'DD-MM-YYYY hh:mm:ss'
                    ).format()
                ).getTime() === LastSessionUser.getTime()
        )[0]
      },
      async onSwitch(selected) {
        const config = {
          headers: {
            Authorization: `Bearer ${this.jwt}`,
          },
        };
        let user = "";
        await this.user.switchUser(selected).then((response) => {
          localStorage.setItem(
              "user",
              JSON.stringify(response.data.results.data[0])
          );
          user = response.data.results.data[0];
          let fromData = new FormData();
          fromData.append("userid", selected);
          axios.post(location.origin + `/switch.user`, fromData, config).then((response) => {
            if(response.data.status === 'success'){
              this.$store.dispatch("setJwt", { token: this.jwt });
              this.$store.dispatch("setUser", { user: user });
              let actions = new Actions();
              actions.getActions().then((result) => {
                let res = result.status === 200 ? result.data.results.data : [];
                let fil = map(res, function(n) {
                  return Number(n.id);
                });
                this.$store.dispatch("setPermissions", {
                  permissions: fil
                });
              });
            }
          })
        })
      }
    },
    mounted() {
      this.sendEmailVerificationCode();
      let inputs = document.getElementsByClassName('mfa-input-code')
      Lo.map(inputs, input => {
        this.onlyNumbers(input, function (value) {
          return /^-?\d*$/.test(value)
        })
      })
      this.eventsInputsCode()
    },
    created() {
      this.mfaClient = new MfaClient();
      this.user = new User();
    }
  }
</script>

<style lang="scss" scoped>
  @import "./mfa.scss";
</style>
